import React from 'react';

export const Mail: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="4 4 16 16" {...props}>
    <path
      d="M5.536 9.732q.3.206 1.83 1.225t2.339 1.569l.379.262q.29.2.482.327t.464.279a2.743 2.743 0 00.513.232 1.463 1.463 0 00.446.077h.018a1.465 1.465 0 00.446-.077 2.746 2.746 0 00.513-.232q.272-.155.464-.279t.482-.327l.379-.262 4.178-2.795a4.165 4.165 0 001.089-1.058A2.215 2.215 0 0020 7.38a1.3 1.3 0 00-.424-.972 1.407 1.407 0 00-1-.4H5.428a1.3 1.3 0 00-1.058.447A1.694 1.694 0 004 7.565a1.968 1.968 0 00.491 1.174 4.358 4.358 0 001.045.993z"
      fill="currentColor"
    />
    <path
      d="M19.107 10.642q-2.928 1.884-4.446 2.928-.509.356-.826.556a5.2 5.2 0 01-.844.407 2.683 2.683 0 01-.982.208h-.018a2.684 2.684 0 01-.982-.208 5.206 5.206 0 01-.844-.407q-.317-.2-.826-.556-1.205-.84-4.437-2.928a4.67 4.67 0 01-.9-.738v6.738a1.276 1.276 0 00.42.959 1.412 1.412 0 001.009.4h13.14a1.412 1.412 0 001.009-.4 1.275 1.275 0 00.42-.959V9.904a4.859 4.859 0 01-.893.738z"
      fill="currentColor"
    />
  </svg>
);
